import React from 'react'
import { motion } from "motion/react";

import img1 from '../../assets/HomeImg (2).png';
import img2 from '../../assets/HomeImg (1).png';
import img3 from '../../assets/HomeImg (3).png';
import logo from '../../assets/CollapsedLogo.png'

const Specializations = () => {
  const ease = [0.22, 1, 0.36, 1];

  const specializations = [
    {
      img: img1,
      title: "FertiWell",
      subtitle: "Fertility & Reproductive Health",
      points: ["Fertility Support", "Preconception Care", "Reproductive Wellness"],
    },
    {
      img: img2,
      title: "HerCare",
      subtitle: "Women's Health",
      points: ["PCOS / PCOD", "Irregular Periods / Menstrual Wellness", "Hormonal Imbalance"],
    },
    {
      img: img3,
      title: "NovaLife",
      subtitle: "Holistic Wellness",
      points: ["Detox & Rejuvenation", "Stress Management", "Lifestyle Guidance"],
    },
  ];
  return (
    <div>
      <div className="relative bg-brand-forest py-20 overflow-hidden">

        <div className="relative max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-wide">
              Our Specialization
            </h2>
            <div className="flex items-center justify-center gap-3">
              <span className="h-px w-16 bg-white/25" />
              <img
                src={logo}
                alt={logo}
                className="relative w-20 h-20 object-contain "
              />        <span className="h-px w-16 bg-white/25" />
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.15 } } }}
            className="grid grid-cols-1 sm:grid-cols-3 gap-12 sm:gap-8"
          >
            {specializations.map((spec, idx) => (
              <motion.div
                key={idx}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease } },
                }}
                className="group flex flex-col items-center text-center"
              >
                {/* image medallion */}
                <div className="relative w-44 h-44 mb-6">
                  <div className="absolute inset-0 rounded-full border border-brand-gold/40 scale-100 group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-2 rounded-full bg-white/5 group-hover:bg-white/10 transition-colors duration-500" />
                  <img
                    src={spec.img}
                    alt={spec.title}
                    className="relative w-full h-full object-contain p-4 group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                <h3 className="text-xl font-bold text-white mb-1.5">{spec.title}</h3>
                <p className="text-[11px] uppercase tracking-widest text-brand-gold font-semibold mb-5">
                  {spec.subtitle}
                </p>

                <ul className="space-y-2.5">
                  {spec.points.map((point, i) => (
                    <li key={i} className="flex items-center gap-2.5 text-sm text-brand-emerald/90 ">
                      <span className="w-1.5 h-1.5 rounded-full bg-brand-gold shrink-0" />
                      {point}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Specializations